// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FolderDeepLinkPage {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    background: #fff;
    padding: 20px;
    box-sizing: border-box;
}

.FolderDeepLinkPage_loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 16px;
    color: #666;
}

.FolderDeepLinkPage_error {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #e74c3c;
    font-size: 16px;
}

.FolderDeepLinkPage_header {
    padding-bottom: 16px;
    border-bottom: 1px solid #eee;
    margin-bottom: 16px;
}

.FolderDeepLinkPage_content {
    flex: 1;
    overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/folderPage/FolderDeepLinkPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,gBAAgB;AACpB","sourcesContent":[".FolderDeepLinkPage {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100vh;\n    background: #fff;\n    padding: 20px;\n    box-sizing: border-box;\n}\n\n.FolderDeepLinkPage_loading {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    gap: 16px;\n    color: #666;\n}\n\n.FolderDeepLinkPage_error {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    color: #e74c3c;\n    font-size: 16px;\n}\n\n.FolderDeepLinkPage_header {\n    padding-bottom: 16px;\n    border-bottom: 1px solid #eee;\n    margin-bottom: 16px;\n}\n\n.FolderDeepLinkPage_content {\n    flex: 1;\n    overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
